import { api, ApiRequestConfig } from './api';
import { FetchLoyaltyPointsDTO } from '../types/loyalty';
import { LOYALTY_ACCOUNT_API } from './constants';

interface IGetLoyaltyAccountParams {
  regionId: string;
  loyaltyAccountIdentifier: string;
}

export const getLoyaltyPointsRequest = (
  { regionId, loyaltyAccountIdentifier }: IGetLoyaltyAccountParams,
  config: ApiRequestConfig,
) =>
  api.get<FetchLoyaltyPointsDTO>(
    `${LOYALTY_ACCOUNT_API}/${loyaltyAccountIdentifier}/points`,
    { regionId },
    config,
  );
